/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { FunctionComponent } from "react"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

interface Props {
  description?: string
  lang?: string
  meta?: {
    name: string
    content: string
  }[]
  title: string
  ogImage: string
}

const SEO: FunctionComponent<Props> = ({
  description = "",
  meta = [],
  title,
  children,
  ogImage,
}) => {
  const { site } = useStaticQuery(
    graphql`
      query SEOData {
        site {
          siteMetadata {
            title
            description
            siteUrl
          }
        }
      }
    `
  )

  const metaDescription = (description || site?.siteMetadata?.description) ?? ""

  return (
    <Helmet
      title={title}
      titleTemplate={`%s | ${site?.siteMetadata?.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: `${site?.siteMetadata?.siteUrl}${ogImage}`,
        },
      ].concat(meta)}
    >
      {children}
    </Helmet>
  )
}

export default SEO
